export default __webpack_public_path__ + "static/media/valorant_logo_long.c5addbac.png";